<template>
    <v-flex>
        <h1>Erro 404</h1>
    </v-flex>
</template>

<script>
    export default {
        name: "Erro404"
    }
</script>

<style scoped>

</style>